module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("回饋金查詢")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "language": "zh",
      "format": "yyyy-MM",
      "placeholder": "可查詢不同月份"
    },
    model: {
      value: (_vm.choosemonth),
      callback: function($$v) {
        _vm.choosemonth = $$v
      },
      expression: "choosemonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.searchFlag
    },
    on: {
      "click": function($event) {
        _vm.getPerformance()
      }
    }
  }, [_vm._v("查詢")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v("志工點數餘額： " + _vm._s(this.volunteerQuota) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeenvolunteerQuota),
      expression: "redeenvolunteerQuota"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "請輸入預計折抵點數"
    },
    domProps: {
      "value": (_vm.redeenvolunteerQuota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeenvolunteerQuota = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.redeenFlag
    },
    on: {
      "click": function($event) {
        _vm.redeenVolunteer()
      }
    }
  }, [_vm._v("確認折抵")])])]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.performance), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.level))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.org_mid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.org_name))]), _vm._v(" "), (row.level === 0) ? _c('td', [_vm._v("\n                  總額: " + _vm._s(row.price)), _c('br'), _vm._v("\n                  一般商品:" + _vm._s(row.bonusL)), _c('br'), _vm._v("\n                  指定商品:" + _vm._s(row.bonusH) + "\n                  ")]) : _c('td', [_vm._v(_vm._s(row.price))]), _vm._v(" "), (row.level === 0) ? _c('td', [_vm._v(_vm._s(row.point))]) : _c('td', [_vm._v(_vm._s(Math.round(row.point, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.percentage) + "%")]), _vm._v(" "), (row.level === 0) ? _c('td', [_vm._v("\n                    " + _vm._s(row.person_bonus) + "\n                  ")]) : _c('td', [_vm._v("\n                    " + _vm._s(Math.round(row.bonus * 100) / 100) + "\n                  ")])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n                  最高可領金額: " + _vm._s(this.Minimum) + " 元"), _c('br'), _vm._v("\n                  (本月已折抵志工點數 : " + _vm._s(this.personalMaxBonus) + ") "), _c('br'), _c('br'), _vm._v("\n                  個人回饋金: " + _vm._s(this.personal)), _c('br'), _vm._v("\n                  組織回饋金: " + _vm._s(Math.round(this.group * 100) / 100)), _c('br'), _vm._v("\n                  總計回饋金: " + _vm._s(Math.round(this.totalBonus, 3)) + " 元\n                ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("編號")]), _vm._v(" "), _c('td', [_vm._v("姓名")]), _vm._v(" "), _c('td', [_vm._v("總消費額")]), _vm._v(" "), _c('td', [_vm._v("總點數")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("回饋金")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fd385b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/Performance.vue
// module id = 301
// module chunks = 1